import { Fire, SalesEndSoon, Popular, JustAdded } from './icons';
import type { BadgeInfo } from './badgeInfo';
import { defineMessage } from 'react-intl';

export const badges: Array<BadgeInfo> = [
  {
    signal: 'goingFast',
    type: 'message',
    priority: 1,
    text: defineMessage({ id: 'Going fast', defaultMessage: 'Going fast' }),
    style: 'danger',
    icon: <Fire width={16} height={16} />,
  },
  {
    signal: 'fewTickets',
    type: 'message',
    priority: 2,
    text: defineMessage({ id: 'Few tickets left', defaultMessage: 'Few tickets left' }),
    style: 'danger',
    icon: <Fire width={16} height={16} />,
  },
  {
    signal: 'salesEndSoon',
    type: 'message',
    priority: 3,
    text: defineMessage({ id: 'Sales end soon', defaultMessage: 'Sales end soon' }),
    style: 'warning',
    icon: <SalesEndSoon width={16} height={16} />,
  },

  {
    signal: 'popular',
    type: 'category',
    priority: 4,
    text: defineMessage({ id: 'Popular', defaultMessage: 'Popular' }),
    style: 'success',
    icon: <Popular width={16} height={16} />,
  },
  {
    signal: 'new',
    type: 'category',
    priority: 5,
    text: defineMessage({ id: 'Just Added', defaultMessage: 'Just Added' }),
    style: 'success',
    icon: <JustAdded width={16} height={16} />,
  },
];
